// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { trash16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-trash': IconTrash;
    }
}

/**
 * The icon component for the 'trash' icon
 */
export class IconTrash extends IconSvg {
    public constructor() {
        super(trash16X16);
    }
}

registerIconSvg('icon-trash', IconTrash);
export const iconTrashTag = 'nimble-icon-trash';
